import React,{Component} from 'react'
import {connect} from "react-redux"
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

class Filters extends Component{
    constructor (props) {
        super(props)
        
        let {data} = this.props;   

        this.state={
            periodStart:moment(),
            periodEnd:  moment(),
            data: data
        }
      }

    componentDidMount(){
        let {data} = this.props;        
    }
    
    handleOnBindingTypeChange(e){
        this.handleFieldChange("bindingType",e.target.value)
    }
    handleFieldChange(field,value){
        let {data} = this.props
        let filters = {
            ...data,
            [field]:value
        }
        this.funcThrowFilters(filters);
    }
    handlePeriodStartChange(field,value){        
        this.setState({periodStart: value});
        let {data} = this.props
        let filters = {
            ...data,
            [field]:moment(value).format("DD/MM/YYYY")
        }
        this.funcThrowFilters(filters);
    }
    handlePeriodEndChange(field,value){
        this.setState({periodEnd: value});
        let {data} = this.props
        let filters = {
            ...data,
            [field]:moment(value).format("DD/MM/YYYY")
        }
        this.funcThrowFilters(filters);
    }
    handleOnReset() {        
        if (this.props.onReset) {
            this.props.onReset();
        }
    }

    funcThrowFilters(filters) {
        if (this.props.onFiltersChange) {
            this.props.onFiltersChange(filters);
        }
    }

    render(){
        let {data,config} = this.props        

        return(
            <div className="c-filters">
                <div className="row">     
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>Поиск по артикулу: </label>
                            <div className="uploader">
                                <input type="text" value={data.offerId} className="form-control" placeholder="Поиск по коду" 
                                    onChange={(e) => this.handleFieldChange("offerId", e.target.value)}/>                                                                           
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>Поиск по назанию: </label>
                            <div className="uploader">
                                <input type="text" value={data.offerName} className="form-control" placeholder="Поиск по названию" 
                                    onChange={(e) => this.handleFieldChange("offerName", e.target.value)}/>
                                                                            
                            </div>
                        </div>
                    </div>   
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>Наличие: </label>
                            <div className="uploader">
                                <select className="select form-control" value={data.isAvailable} 
                                        onChange={(e) => this.handleFieldChange("isAvailable", e.target.value)}>
                                            <option value="0">Все</option>
                                            <option value="1">В наличии</option>
                                            <option value="2">Не в наличии</option>                                            
                                        </select>                                                
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>Активный: </label>
                            <div className="uploader">
                            <select className="select form-control" value={data.isActive} 
                                onChange={(e) => this.handleFieldChange("isActive", e.target.value)}>
                                            <option value="0">Все</option>
                                            <option value="1">Активные</option>
                                            <option value="2">Не Активные</option>                                            
                                        </select>                                                 
                            </div>
                        </div>
                    </div>                    
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>Начало периода: </label>
                            <div className="uploader">
                                <DatePicker
                                    className="form-control"
                                    value={data.periodStart}
                                    selected={this.state.periodStart}
                                    onChange={(e) => this.handlePeriodStartChange("periodStart", e)}                                   
                                />                                                                                                      
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>Конец периода: </label>
                            <div className="uploader">
                            <DatePicker
                                    className="form-control"
                                    selected={this.state.periodEnd}
                                    onChange={this.handlePeriodEndChange}
                                    onChange={(e) => this.handlePeriodEndChange("periodEnd", e)}
                                />                                                                        
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 filters-controls col-md-offset-3">
                        <div className="row">
                            <div className="col-sm-6">
                                {/*<button className="btn btn-submit" >Применить</button>*/}
                            </div>
                            <div className="col-sm-6">
                                <button className="btn btn-reset" onClick={() => this.handleOnReset()}>Сбросить</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
function mapStateToProps(state) {
    return{
        config:state.config,
    }
}

export default connect(mapStateToProps)(Filters);


// WEBPACK FOOTER //
// ./src/components/Dashboard/Errors/Filters.jsx